import MadriwaLogo from '../../ui/madriwaLogo/madriwa-logo';

type PageProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Page: React.FC<PageProps> = ({ className, children }) => {
  return (
    <div className={`relative h-screen w-screen ${className}`}>
      <div className="flex h-full w-full flex-col items-center justify-center">
        <div className="mb-[1rem] h-[6rem] w-[calc(100%-2rem)] sm:mb-[0.5rem] sm:h-[7rem] sm:w-[500px] md:w-[650px] lg:w-[850px]">
          <a
            className="flex h-full w-full flex-col items-center justify-end"
            href="https://madriwa.taniwa.es/"
            target="blank"
          >
            <MadriwaLogo className="mb-2 border-b border-madriwaGreen  pb-2" size="large" />
            <div className="flex flex-col items-center leading-4 sm:pb-3">
              <h1 className="bold font-['Roboto'] text-[1.1rem] font-light text-madriwaGreen">
                Encuentra tu barrio en Madrid
              </h1>
              <h2 className="text-[0.8rem] font-normal text-madriwaGrey">
                Datos y geointeligencia a tu servicio
              </h2>
            </div>
          </a>
        </div>
        <div className="h-[calc(100%-9rem)] w-[calc(100%-2rem)] shadow drop-shadow sm:h-3/4 sm:w-[500px] sm:rounded-lg md:w-[650px] lg:w-[850px]">
          <div className="h-full w-full overflow-hidden rounded-md sm:rounded-lg">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Page;
